/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { cssMap, keyframes, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';
interface Props {
	children: React.ReactNode;
	className?: string;
	disableAnimation?: boolean;
	tag?: keyof JSX.IntrinsicElements;
}

const fadeIn = keyframes({
	to: {
		opacity: 1,
	},
});

const fadeInStyles = cssMap({
	noFade: {
		opacity: 1,
		margin: 0,
		padding: 0,
		color: token('color.text'),
	},
	root: {
		animationName: fadeIn,
		animationDuration: '500ms',
		animationTimingFunction: 'ease',
		animationFillMode: 'forwards',
		opacity: 0,
		margin: 0,
		padding: 0,
		color: token('color.text'),
	},
});

export const FadeIn = ({ children, className, disableAnimation, tag: Tag = 'div' }: Props) => (
	<Tag
		// FadeIn breaks the drag preview, so we need a way to disable it
		css={(disableAnimation && fadeInStyles.noFade) || (!disableAnimation && fadeInStyles.root)}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={className}
	>
		{children}
	</Tag>
);
